import { FormatType } from '../../types';
import { getFormatter } from '../../utilities';
import styles from './single-metric-chart.module.css';

const SI_THRESHOLD = 1_000_000;
const formatSI = getFormatter(FormatType.SI);

function formatValueIfLarge(value: string): string {
  const normalized = value.replace(/,/g, '').trim();
  const n = Number(normalized);
  if (!Number.isFinite(n) || Math.abs(n) < SI_THRESHOLD) {
    return value;
  }
  return formatSI(n);
}

export type SingleMetricChartProps = {
  value: string;
  label?: string;
};

export const SingleMetricChart = ({ value, label }: SingleMetricChartProps) => {
  const displayValue = formatValueIfLarge(value);

  return (
    <div className={styles.container}>
      <div className={styles.value}>{displayValue}</div>
      {label && <div className={styles.label}>{label}</div>}
    </div>
  );
};
